import React from 'react';

/**
 * Image component that can be used either with a single image source or multiple image sources.
 * @param {Object[]} [srcSet=[]] - An array of image sources represented as objects. Each object has the following properties:
 *   - src: A string that represents the source
 *   - type: A string that represents the image type, such as 'image/webp'.
 * @param {React.ComponentType} [overrideNativeComponent=null] - An optional component to render the image instead of the default 'img' component.
 * @param {Object} [sx] - Style object to be passed to the component for styling using styled-components.
 * @param {...any} rest - Any other props to be passed to the component, such as 'alt', 'src', etc.
 */
export default function Image({ srcSet = [], overrideNativeComponent = null, sx, ...rest }) {
  const Img = overrideNativeComponent || 'img';
  if (srcSet.length === 0) {
    return <Img {...rest} sx={sx} />;
  } else {
    return (
      <picture>
        {srcSet.map((img, index) => {
          return <source key={index} style={sx} type={img.type} srcSet={img.src} />;
        })}
        <Img {...rest} sx={sx} />
      </picture>
    );
  }
}